<template>
    <div class="api-settings">
        <div class="row" style="margin-top: 1vh;" v-if="api_available === true">
            <div class="col-md-1 flex-col">
                <div>
                    {{ t_api_active }}
                </div>
                <div class="form-group flex-group">
                    <select aria-label="use" class="form-control" name="api_active" v-model="api_active">
                        <option :value="1">{{ t_yes }}</option>
                        <option :value="0">{{ t_no }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div>
                    {{ t_api_key }}
                    <span @click="copyValueToClipboard(api_key)"><i class="fa-regular fa-copy cursor-pointer"></i></span>
                </div>
                <div class="form-group flex-group">
                    <input aria-label="api key" type="text" v-model="api_key" name="api_key" class="form-control" readonly>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_api_layer_id }}
                    <span :data-balloon="t_layer_description" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa-regular fa-circle-question cursor-pointer"></i>
                            </span>
                </div>
                <div class="form-group">
                    <select aria-label="name" class="form-control" name="api_layer_id" :disabled="api_active !== 1" v-model="api_layer_id">
                        <template v-for="layer in all_layers">
                            <option v-if="layer['nr'] !== adtrac_layer" :value="layer['nr']">{{ layer['name'] }}</option>
                        </template>
                    </select>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_api_user }}
                </div>
                <div class="form-group flex-group">
                    <input aria-label="username" type="text" :disabled="api_active !== 1" v-model="api_user" name="api_username" class="form-control">
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_api_password }}
                </div>
                <div class="form-group flex-group">
                    <input aria-label="password" type="text" :disabled="api_active !== 1" v-model="api_password" name="api_password" class="form-control">
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_api_doc }}
                </div>
                <div class="form-group flex-group">
                    <a href="/api/documentation" class="p-w-xs" target="_blank">
                        LINK
                    </a>
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                </div>
            </div>
        </div>
        <hr v-if="api_available === true && adtrac_available === true">
        <div class="row" :style="api_available === true ? '' : 'margin-top: 1vh;'" v-if="adtrac_available === true">
            <div class="col-md-1 flex-col">
                <div>
                    {{ t_adtrac_active }}
                </div>
                <div class="form-group flex-group">
                    <select aria-label="adtrac" class="form-control" name="adtrac_active" v-model="adtrac_active">
                        <option :value="1">{{ t_yes }}</option>
                        <option :value="0">{{ t_no }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div>
                    {{ t_adtrac_apikey }}
                </div>
                <div class="form-group flex-group">
                    <input aria-label="adtrac key" type="text" v-model="adtrac_apikey" name="adtrac_apikey" class="form-control" :disabled="adtrac_active !== 1">
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_adtrac_layer }}
                    <span :data-balloon="t_layer_description" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa-regular fa-circle-question cursor-pointer"></i>
                            </span>
                </div>
                <div class="form-group flex-group">
                    <select aria-label="layer" class="form-control" name="adtrac_layer" :disabled="adtrac_active !== 1" v-model="adtrac_layer">
                        <template v-for="layer in all_layers">
                            <option v-if="layer['nr'] !== api_layer_id" :value="layer['nr']">{{ layer['name'] }}</option>
                        </template>
                    </select>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_adtrac_default_duration }}
                    <span :data-balloon="t_adtrac_default_duration_description" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa-regular fa-circle-question cursor-pointer"></i>
                            </span>
                </div>
                <div class="form-group flex-group">
                    <input aria-label="default duration" type="text" v-model="adtrac_default_duration" name="adtrac_default_duration" class="form-control" :disabled="adtrac_active !== 1">
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_adtrac_upto }}
                    <span :data-balloon="t_adtrac_upto_description" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa-regular fa-question-circle cursor-pointer"></i>
                            </span>
                </div>
                <div class="form-group flex-group">
                    <input aria-label="up to" type="text"  v-model="adtrac_upto" name="adtrac_upto" class="form-control" :disabled="adtrac_active !== 1">
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div>
                    {{ t_adtrac_keep_on_playing }}
                    <span :data-balloon="t_adtrac_keep_on_playing_description" data-balloon-pos="left" data-balloon-length="large">
                                <i class="fa-regular fa-circle-question cursor-pointer"></i>
                            </span>
                </div>
                <div class="form-group flex-group">
                    <select aria-label="keep playing" v-model="adtrac_keep_on_playing" class="form-control" name="adtrac_keep_on_playing" :disabled="adtrac_active !== 1">
                        <option value="1">{{ t_yes }}</option>
                        <option value="0">{{ t_no }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12" v-if="adtrac_api_endpoint">
                <div>
                    {{ t_adtrac_api_endpoint }}
                    <span @click="copyValueToClipboard(adtrac_api_endpoint)"><i class="fa-regular fa-copy cursor-pointer"></i></span>
                </div>
                <input aria-label="api endpoint" type="text" v-model="adtrac_api_endpoint" name="adtrac_api_endpoint" class="form-control" readonly>
            </div>
            <div class="col-md-12">
                <div>
                    {{ t_adtrac_adrequest_url }}
                </div>
                <input aria-label="adrequest url" type="text" v-model="adtrac_adrequest_url" name="adtrac_adrequest_url" class="form-control" :disabled="adtrac_active !== 1">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'api_available',
        'adtrac_available',
    ],
    data: function () {
        return {
            t_yes: Lang.langGet("Yes"),
            t_no: Lang.langGet("No"),
            t_clipboard: Lang.langGet("Copied to clipboard"),

            t_api_active: Lang.langGet("Use API"),
            t_api_key: Lang.langGet("X-API-KEY"),
            t_api_user: Lang.langGet("API Authentication") + ' ' + Lang.langGet("Username"),
            t_api_password: Lang.langGet("API Authentication") + ' ' + Lang.langGet("Password"),
            t_api_layer_id: Lang.langGet("Layer to use for API"),
            t_api_doc: Lang.langGet("API Documentation"),

            t_layer_description: Lang.langGet("This layer will be reserved and can not be used to publish content manually. Existing content will be overwritten."),

            t_adtrac_active: Lang.langGet("Use Adtrac"),
            t_adtrac_layer: Lang.langGet("Layer to use for Adtrac content"),
            t_adtrac_apikey: Lang.langGet("API Key for requests by Adtrac"),
            t_adtrac_default_duration: Lang.langGet("Default duration"),
            t_adtrac_default_duration_description: Lang.langGet("Duration a picture retrieved from Adtrac is displayed."),
            t_adtrac_upto: Lang.langGet("Up To Elements"),
            t_adtrac_upto_description: Lang.langGet("Play up to ... elements one after another. Value 0 means play the whole list. Negative values mean up to ... seconds."),
            t_adtrac_keep_on_playing: Lang.langGet("Keep on playing"),
            t_adtrac_keep_on_playing_description: Lang.langGet("Keep on playing past Adtrac content, if no new content was retrieved in the meantime."),
            t_adtrac_api_endpoint: Lang.langGet("Adtrac API endpoint"),
            t_adtrac_adrequest_url: Lang.langGet("Adtrac programmatic/adrequest action"),

            id: null,
            api_active: 0,
            api_key: '',
            api_user: '',
            api_password: '',
            api_layer_id: null,
            api_doc: '',
            adtrac_active: 0,
            adtrac_default_duration: 0,
            adtrac_layer: null,
            adtrac_upto: 0,
            adtrac_apikey: '',
            adtrac_keep_on_playing: 0,
            adtrac_api_endpoint: '',
            adtrac_adrequest_url: '',
            all_layers: {},
        }
    },
    methods: {
        copyValueToClipboard(value) {
            if (!navigator.clipboard) {
                toastr["error"](Lang.langGet('Could not copy to clipboard.'));
                console.error(Lang.langGet('Clipboard is undefined - are you in a secure context?'));
            } else {
                navigator.clipboard.writeText(value).then(() => {
                    toastr["success"](this.t_clipboard);
                }).catch(() => {
                    toastr["error"](Lang.langGet('Could not copy to clipboard.'));
                });
            }
        }
    },
    mounted() {
        EaseEventBus.listen('data-api-settings-tab', (data) => {
            this.id = data.id;

            this.api_active = data.api_active;
            this.api_key = data.api_key;
            this.api_user = data.api_username;
            this.api_password = data.api_password;

            this.adtrac_upto = data.adtrac_upto;
            this.adtrac_keep_on_playing = data.adtrac_keep_on_playing;
            this.adtrac_default_duration = data.adtrac_default_duration;
            this.adtrac_apikey = data.adtrac_apikey;
            this.adtrac_active = data.adtrac_active;
            this.adtrac_api_endpoint = data.adtrac_api_endpoint;
            this.adtrac_adrequest_url = data.adtrac_adrequest_url;

        });

        EaseEventBus.listen('buildLayers', (data) => {
            const all_layers = {
                'layer_null': {'name': Lang.langGet("None"), 'nr': null}
            };

            data.fields.filter(f => !f.is_calendar).forEach((element) => {
                if (data.switch_off_times && element['nr'] === 0) {
                    return;
                }
                all_layers['layer_' + element['id']] = element;
            });

            this.all_layers = all_layers;
            this.adtrac_layer = data.adtrac_layer;
            this.api_layer_id = data.api_layer_id;
        });
    }
}
</script>

<style scoped>
    .flex-col {
        display: flex;
        justify-content: space-between;
        flex-flow: column;

        .flex-group {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
